import styled from 'styled-components';
import colors from '../../styles/theme/colors';
import { sizes } from '../../styles/theme/devices';
import spaces from '../../styles/theme/spaces';

const Container = styled.footer`
  align-items: center;
  background-color: ${colors.default.white};
  bottom: 0;
  box-shadow: 0 4px 30px 0 ${colors.default.black05};
  display: flex;
  justify-content: center;
  padding-top: ${(props) => props.$hasMarginTop ? spaces.extraSmall : ''};
  position: fixed;
  width: 100%;
  z-index: 2;

  @media (min-width: ${sizes.tablet}) {
    margin-top: ${(props) => props.$hasMarginTop ? spaces.small : ''};
  }
`;

const Action = styled.div`
  align-items: center;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  height: 100%;
  margin: 0 auto;
  padding: ${spaces.xs};
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth || '100%'};

  & > *:only-child {
    margin-left: auto;
  }
  
  @media (min-width: ${sizes.tablet}) {
    max-width: ${({ $maxWidth }) => $maxWidth || sizes.tablet};
    justify-content: ${({ $splitActions }) => ($splitActions ? 'space-between' : 'center')};
    padding: ${spaces.xs} ${spaces.small};
    gap: ${({ $splitActions }) => ($splitActions ? '0' : spaces.small)};

    & > *:only-child {
      margin-left: unset;
    }
  }

  .MuiButton-root {
    margin: 0;
  }

  button {
    background-color: ${colors.secondary.main};
    border-radius: 8px;
    padding: 8px 16px;

    @media (min-width: ${sizes.tablet}) {
      padding: 8px 24px;
    }

    & > p {
      margin-left: 3px;
      letter-spacing: normal;
    }

    div,
    p {
      font-size: 14px;
      font-weight: 500;

      @media (min-width: ${sizes.tablet}) {
        font-size: 16px;
      }
    }

    svg {
      height: 26px;
      margin: 0 0 0 8px;
      width: 26px;
    }

    &.stroke {
      font-family: 'Poppins';
      background-color: ${colors.default.white};
      font-size: 14px;
      font-weight: 500;
      text-decoration: none;
      color: ${colors.secondary.main};
      margin-top: 0;
      padding: 8px 16px;
      min-width: 0;
      border: 1px solid ${colors.secondary.main};
      border-radius: 8px;

      @media (min-width: ${sizes.tablet}) {
        font-size: 16px;
        padding: 8px 24px;
      }

      &:hover {
        background-color: ${colors.secondary.light} !important;
        border-color: ${colors.secondary.main} !important;
        color: ${colors.secondary.main} !important;
      }
    }

    &.outline {
      font-family: 'Poppins';
      background-color: unset;
      font-size: 16px;
      font-weight: 500;
      text-decoration: underline;
      color: ${colors.gray[600]};
      margin-top: 0;
      padding: 0;
      min-width: 0;
      border: none;

      &:hover {
        background-color: unset !important;
        border: none !important;
        color: ${colors.gray[500]} !important;
      }
    }
  }
`;

const ActionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${spaces.small};
`;


export { Action, ActionGroup, Container };
